import styled from '@emotion/styled';
import { Button } from 'ds/components/button';
import { SmallText } from 'ds/components/typography';

export const FormWrapper = styled.form`
  width: 354px;
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    width: auto;
  `}
  position: relative;
  .hosted-fields-invalid {
    border-color: red;
  }
`;

export const FormPreloader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: -98px -40px -75px;
  background-color: #fff;
  z-index: 1;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: ${({ theme }) => theme.spacing(0.5)};
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  & > div:first-of-type {
    height: 52px;
  }
`;

export const HalfSection = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};

  & > div {
    flex: 1;
    display: flex;
  }
`;

export const TermsLink = styled.div`
  text-align: center;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutrals.grey3};
  & > a {
    font-size: inherit;
    line-height: inherit;
    color: inherit;
  }
`;

export const ErrMsg = styled(SmallText)`
  color: #FF6658;
`;

export const IconWrapper = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OkIconWrapper = styled.div`
  margin-right: ${({ theme }) => theme.spacing(0.5)};
`;

export const Wrapper = styled.div<{ isGPayMode?: boolean }>`
  display: flex;
  justify-content: center;
  position: relative;
  padding: ${({ theme }) => theme.spacing(5)};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: ${theme.spacing(4)} ${theme.spacing(3)};
  `}
  flex-direction: ${({ isGPayMode }) => isGPayMode ? 'column' : 'initial'};
`;

export const PaymentButton = styled(Button)<{ isEnabled: boolean }>`
  visibility: ${({ isEnabled }) => (isEnabled ? 'visible' : 'hidden')};
  opacity: ${({ isEnabled }) => (isEnabled ? '1' : '0')};
  pointer-events: ${({ isEnabled }) => (isEnabled ? 'all' : 'none')};
  height: ${({ isEnabled }) => (isEnabled ? undefined : '0px')};
  overflow: ${({ isEnabled }) => (isEnabled ? 'visible' : 'hidden')};
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-size: 13px;
  position: relative;
  & > svg {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
  }
  &:hover > svg path,
  & > svg path {
    fill: revert-layer;
  }
`;

export const BackIconWrapper = styled.div`
  position: absolute;
  top: -46px;
  right: 20px;
  z-index: 3;
`;
